import { reducer as groups } from 'containers/Group';
import { reducer as groupMembers } from 'data/GroupMembers';
import { reducer as progressTests } from 'data/ProgressTests';
import { reducer as progressReports } from 'data/ProgressReports';
import { reducer as reportSummaries } from 'data/ProgressReports/StudentReportSummaries';
import { reducer as approveByDos } from 'data/ProgressReports/ApproveByDos';
import { reducer as sessionPlans } from 'data/SessionPlans';
import { reducer as groupPerformance } from 'data/GroupPerformance';
import { reducer as sessionsAttendance } from 'data/SessionsAttendance';
import { reducer as courseProgress } from 'data/CourseProgress';
import { reducer as coveredInClassContent } from 'data/CoveredInClass';
import { reducer as coveredInClassTemplate } from 'data/CoveredInClass/Template';
import { reducer as cicCategoryTemplate } from 'data/CoveredInClass/CategoryTemplate';
import { reducer as internalNotes } from 'data/InternalNotes';
import { reducer as scoreBand } from 'data/ScoreBand';
import { reducer as language } from 'data/Language';
import { reducer as onlineHomework } from 'data/OnlineHomework';
import { reducer as studentTotalPoints } from 'data/OnlineHomework/TotalPoint';
import { reducer as onlineUsage } from 'data/OnlineUsage';
import { reducer as apiError } from 'data/ApiError';
import { reducer as unit } from 'data/Units';
import { reducer as mentor } from 'data/Mentor';
import { reducer as progressTestsPlan } from 'data/ProgressTestsPlan';
import { reducer as progressTestOverview } from 'data/ProgressTestOverview';
import { reducer as user } from 'data/Users';
import { reducer as centres } from 'data/Centre';
import { reducer as onlineHomeworkContent } from 'data/OnlineHomework/Content';
import { reducer as progressTestViewLink } from 'data/ProgressTests/ViewLink';
import { reducer as uiState } from 'data/UiState';
import {
  reducer as taskFitlerResult,
  dosTaskFilterResult,
  taskOwnersResult,
  taskCentres,
  taskTypes,
  taskStatisticResult,
} from 'data/Tasks';
import { reducer as homework } from 'data/Homework';
import { reducer as personalisedHomework } from 'data/OnlineHomework/Personalised';
import { reducer as onlineHomeworkHFUsage } from 'data/OnlineHomework/HFUsage';
import { reducer as attendanceHistory } from 'data/AttendanceHistory';
import { reducer as paperBasedHomework } from 'data/PaperBasedHomework';
import { reducer as homeworkContent } from 'data/Homework/Content';
import { reducer as homeworkTemplate } from 'data/Homework/Template';
import {
  individualDevelopmentPlanList,
  individualDevelopmentPlan,
  idpApprovalList,
  idpParticipation,
} from 'data/IndividualDevelopmentPlans';
import { reducer as studyPlan } from 'data/IndividualDevelopmentPlans/StudyPlan';
import { reducer as overallDevelopment } from 'data/IndividualDevelopmentPlans/OverallDevelopment';
import {
  reducer as academicInfoGroups,
  academicInfoConcernsStudentSkills,
} from 'data/AcademicInfo';
import { reducer as academicInfoSummary } from 'data/AcademicInfo/Summary';
import { reducer as student } from 'containers/Student';
import { reducer as skillRecommendation } from 'data/SkillRecommendation';
import { reducer as notifications } from 'data/Users/Notifications';
import { reducer as studentNotes } from 'containers/Student/Note';
import { reducer as homeworkTypes } from 'data/Homework/Types';
import { reducer as practicePlay } from 'data/PracticePlay';
import { reducer as unlockHomework } from 'data/UnlockHomework';
import {
  spinReducer as spinWritingAssignment,
  coreReducer as coreWritingAssignment,
  essayReducer as essay,
  shortAnswerReducer as shortAnswer,
} from 'data/WritingAssignment';
import { reducer as grammaPro } from 'data/GrammaPro';
import { reducer as feedback } from 'data/Feedback';
import { reducer as unitQuizResult } from 'data/UnitQuiz';
import { reducer as reader } from 'data/Reader';
import { reducer as vocabulary } from 'data/Vocabulary';
import { reducer as rav2Cic } from 'data/RAv2Cic';
import { reducer as rav2HomeworkResultSummary } from 'data/RAv2HomeworkResultSummary';
import { reducer as rav2HomeworkResultDetail } from 'data/RAv2HomeworkResultDetail';
import { reducer as hf4Homework } from 'data/HF4Homework';
import { reducer as groupLessonAwards } from 'data/GroupLessonAwards';
import { reducer as ketExams } from 'data/KetExams';

export default {
  groups,
  groupMembers,
  groupPerformance,
  sessionPlans,
  sessionsAttendance,
  progressTests,
  progressReports,
  ketExams,
  studentReportSummaries: reportSummaries,
  courseProgress,
  coveredInClassContent,
  internalNotes,
  approveByDos,
  scoreBand,
  language,
  onlineHomework,
  apiError,
  unit,
  mentor,
  progressTestsPlan,
  progressTestOverview,
  user,
  centres,
  onlineHomeworkContent,
  progressTestViewLink,
  uiState,
  taskFitlerResult,
  dosTaskFilterResult,
  taskOwnersResult,
  taskCentres,
  taskTypes,
  homework,
  personalisedHomework,
  taskStatisticResult,
  attendanceHistory,
  paperBasedHomework,
  homeworkContent,
  individualDevelopmentPlanList,
  individualDevelopmentPlan,
  idpApprovalList,
  idpParticipation,
  studyPlan,
  overallDevelopment,
  academicInfoGroups,
  academicInfoConcernsStudentSkills,
  academicInfoSummary,
  student,
  notifications,
  studentNotes,
  homeworkTypes,
  practicePlay,
  onlineUsage,
  skillRecommendation,
  coveredInClassTemplate,
  homeworkTemplate,
  unlockHomework,
  spinWritingAssignment,
  coreWritingAssignment,
  studentTotalPoints,
  essay,
  shortAnswer,
  grammaPro,
  feedback,
  unitQuizResult,
  onlineHomeworkHFUsage,
  cicCategoryTemplate,
  reader,
  vocabulary,
  rav2Cic,
  rav2HomeworkResultSummary,
  rav2HomeworkResultDetail,
  hf4Homework,
  groupLessonAwards,
};



// WEBPACK FOOTER //
// ./rootReducer.js